import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormGroup, Input, Label } from 'reactstrap';

class SuperCheckbox extends PureComponent {
  render() {
    const { className, value, title, titleAttr, desc, onChange } = this.props
    return (
      <div className={classNames('tt-supercheckbox', className)}>
        <FormGroup check style={{ marginTop: 0 }}>
          <Label check>
            <Input
              type="checkbox"
              checked={value || false}
              onChange={onChange}
            />
            <span className="form-check-sign" />
            <div className="tt-supercheckbox-content">
              <div className="tt-supercheckbox-title"><FormattedMessage {...title} values={titleAttr || {}} /></div>
              {desc
                ? <div className="tt-supercheckbox-desc"><FormattedMessage {...desc} /></div>
                : null
              }
            </div>
          </Label>
        </FormGroup>
      </div>
    )
  }
}

SuperCheckbox.propTypes = {
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  titleAttr: PropTypes.object,
  title: PropTypes.object,
  desc: PropTypes.object,
};

export default SuperCheckbox;
